import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

const LazyImage = ({
  src,
  alt,
  className = '',
  width,
  height,
  placeholderSrc,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '200px 0px', // Load images 200px before they come into view
  });

  // Reset loading state when src changes
  useEffect(() => {
    setIsLoaded(false);
    setIsError(false);
  }, [src]);

  // Handle image load event
  const handleImageLoaded = () => {
    setIsLoaded(true);
  };

  // Handle image error
  const handleImageError = () => {
    setIsError(true);
    console.error(`Failed to load image: ${src}`);
  };

  return (
    <div
      ref={ref}
      className={`lazy-image-container ${isLoaded ? 'loaded' : 'loading'} ${className}`}
      style={{ width, height }}
    >
      {inView && (
        <>
          {!isLoaded && placeholderSrc && (
            <img
              src={placeholderSrc}
              alt=""
              className="placeholder"
              aria-hidden="true"
            />
          )}
          <img
            src={src}
            alt={alt}
            className={`lazy-image ${isLoaded ? 'visible' : 'hidden'}`}
            onLoad={handleImageLoaded}
            onError={handleImageError}
            loading="lazy"
            {...props}
          />
          {isError && (
            <div className="image-error">
              <span>Image could not be loaded</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LazyImage;
